import getFavorites from 'owa-session-store/lib/utils/getFavorites';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import loadFavoriteNodesToStore from './loadFavoriteNodesToStore';
import loadOutlookFavorites from './loadOutlookFavorites';
import migrateFavorites from './migrateFavorites';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { logUsage } from 'owa-analytics';
import { trace } from 'owa-trace';
import {
    FirstRunFavoritesMigrationFlag,
    getIsBitEnabled,
    RoamingFavoritesMigrationCompleted,
} from './favoritesBitFlagsActions';

const NOT_FOUND = 'NOT_FOUND';

/**
 * If migration is completed and roaming feature flag is on we will show the outlook favs otherwise
 * we will fallback to the previous implementation.
 */
export default function loadFavorites() {
    const firstRunCompleted = getIsBitEnabled(FirstRunFavoritesMigrationFlag);
    const roamingFavoritesMigrationCompleted = getIsBitEnabled(RoamingFavoritesMigrationCompleted);
    if (isMiniFeatureEnabled('tri-favorites-roaming') && roamingFavoritesMigrationCompleted) {
        try {
            loadOutlookFavorites();
            logUsage('LoadOutlookFavorites');
        } catch (e) {
            // We can be sure that if roaming fav migration for the user is done first run is also done.
            loadFavoriteNodesToStore();

            logUsage('LoadOutlookFavoritesFailed', {
                error: e,
            });
            trace.warn('Failed to load outlook favorites');
        }
    } else {
        if (firstRunCompleted) {
            // Load UserOptions.FavoritesNodes if there is any
            try {
                loadFavoriteNodesToStore();
                logUsage('LoadFavorites');
            } catch (e) {
                logUsage('LoadFavoritesFailed', {
                    error: e,
                });
            }
        } else {
            // Migrate JsMVVM favorites to React if user is not marked as first run completed
            migrateFavorites();
            logUsage('MigrateFavoritesFirstRun');
        }
    }
    logFavoritesInfoFromSession();
}

// Log favorites related information from session data
function logFavoritesInfoFromSession() {
    try {
        const { UserOptions } = getUserConfiguration();
        const favorites = getFavorites()?.value;
        logUsage('NoOfFavsInMiniSessionDataResponse', {
            FavoriteFolders: UserOptions
                ? UserOptions.FavoriteFolders && UserOptions.FavoriteFolders.length
                : NOT_FOUND,
            FavoriteNodes: UserOptions
                ? UserOptions.FavoriteNodes && UserOptions.FavoriteNodes.length
                : NOT_FOUND, // Old favorites
            Favorites: favorites ? favorites.length : NOT_FOUND, // New outlook favorites
            FavoritesBitFlags: UserOptions.FavoritesBitFlags || NOT_FOUND,
        });
    } catch (e) {
        logUsage('NoOfFavsInMiniSessionDataResponse_Failed', {
            error: e,
        });
    }
}
